import React__default, { useCallback } from 'react';
import classnames from 'classnames';
import { connectRange } from 'react-instantsearch-core';
import { Accordion, AccordionItem } from '@grandvisionhq/common';
import FacetContainerMobile from '../FacetContainerMobile/FacetContainerMobile.js';
import FacetInputPriceRange from './FacetInputPriceRange.js';

const ConnectedFacetInputPriceRangeMobile = ({ onChange , refine , id , label , min , max , currentRefinement , expandedState , isActive ,  })=>{
    const clearHandler = useCallback(()=>refine({
            min,
            max
        })
    , [
        min,
        max
    ]);
    const handleOnChange = React__default.useCallback((value)=>{
        onChange && onChange();
        refine(value);
    }, [
        onChange,
        refine
    ]);
    if (min === max) {
        return null;
    }
    const facetListClass = classnames('facet-input-price-range-mobile', {
        'facet-input-price-range-mobile--hidden': expandedState && !isActive
    });
    return /*#__PURE__*/ React__default.createElement(Accordion, {
        className: "facets-mobile__accordion"
    }, /*#__PURE__*/ React__default.createElement(AccordionItem, {
        id: id,
        className: "facets-mobile__accordion__item",
        label: label,
        headingLevel: "h3"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: facetListClass
    }, /*#__PURE__*/ React__default.createElement(FacetContainerMobile, {
        onClear: clearHandler,
        refineCount: 0
    }, /*#__PURE__*/ React__default.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentRefinement,
        facetLabel: label,
        onChange: handleOnChange,
        renderNumber: (value)=>Math.round(value / 100)
    })))));
};
var ConnectedFacetInputPriceRangeMobile$1 = connectRange(ConnectedFacetInputPriceRangeMobile);

export { ConnectedFacetInputPriceRangeMobile, ConnectedFacetInputPriceRangeMobile$1 as default };
//# sourceMappingURL=ConnectedFacetInputPriceRangeMobile.js.map
